import React, { useState } from 'react';
import ImagePreviewModal from './ImagePreviewModal';

export default function withImagePreview<P extends { src: string; alt: string }>(
  WrappedComponent: React.ComponentType<P>
) {
  return function ImagePreviewWrapper(props: P) {
    const [open, setOpen] = useState(false);
    return (
      <>
        <div style={{ position: 'relative', width: '100%', height: '100%' }}>
          <WrappedComponent {...props} />
          {/* Overlay button for click, covers the image but does not affect layout */}
          <div
            style={{
              position: 'absolute',
              top: 0,
              left: 0,
              width: '100%',
              height: '100%',
              cursor: 'zoom-in',
              background: 'transparent',
              zIndex: 2,
            }}
            tabIndex={0}
            role="button"
            aria-label="Preview image"
            onClick={() => setOpen(true)}
            onKeyDown={e => (e.key === 'Enter' || e.key === ' ') && setOpen(true)}
          />
        </div>
        <ImagePreviewModal
          open={open}
          imageUrl={props.src}
          alt={props.alt}
          onClose={() => setOpen(false)}
        />
      </>
    );
  };
}

